import { useState, useEffect } from 'react';
import { useAppSelector } from '../../store/hooks';
import { useMemo } from 'react';
import { selectPermissionsArray } from '@store/Login/authSelectors';
// export const usePermissions = () => {
//   const [permissions, setPermissions] = useState<string[]>([]);

//   const Permission = useAppSelector((s: any) => s.userLogin?.AuthUser?.permission);

//   useEffect(() => {
//     // const decryptedPermissions = DecryptString(localStorage.Permission || "");
//     const permissionsArray = Permission.split(',');
//     setPermissions(permissionsArray);
//   }, []);

//   const HasPermission = (permission: string) => {
//     return permissions.includes(permission);
//   };

//   return { HasPermission };
// };

// export const usePermissions = () => {
//   const HasPermission = (permission: string) => {
//     return true;
//   };

//   return { HasPermission };
// };

export const usePermissions = () => {
  // الحصول على الصلاحيات مباشرة كـ Array من السيليكتر
  const permissions = useAppSelector(selectPermissionsArray);
  // console.log(permissions);
  

  // دالة فحص الصلاحيات، وتُنشأ بـ useMemo لتجنب إعادة الإنشاء بلا داعٍ
  const HasPermission = useMemo(() => (permission: string) => permissions.includes(permission), [permissions]);

  // const HasPermission = (permission: string) => {
  //   return true;
  // };

  return { HasPermission };
};
